import Common from "../../../Common";
import UserSetting from "./usersettings/UserSetting";

interface Body {
	name: string
	description: string
}

const UserSettings = class extends Common {
	userSetting: InstanceType<typeof UserSetting>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.userSetting = new UserSetting(headers);
	}

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/templates/usersettings/${id}`)

	browse = (companyId: id) =>
		this.get(`/company/${companyId}/templates/usersettings`)

	browseBelongingProfiles = (companyId: id, templateId: id) =>
		this.get(`/company/${companyId}/templates/usersettings/${templateId}/browseBelongingProfiles`)

	access = (companyId: id, templateId: id) =>
		this.get(`/company/${companyId}/templates/usersettings/access/${templateId}`)

	clone = (companyId: id, id: id, body: TemplateCloneBody = {}) =>
		this.post(`/company/${companyId}/templates/usersettings/${id}/clone`, body)

	update = (companyId: id, id: id, body: Body) =>
		this.patch(`/company/${companyId}/templates/usersettings/${id}`, body)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/templates/usersettings/${id}`)
}

export default UserSettings
